export const projects = [
    {
      title: "ProgramaRed",
      subtitle: "React-Redux Node Express Tailwind Firebase Nodemailer",
      description:
        "Para aprobar el bootcamp de Henry es necesario realizar un proyecto final grupal con entorno de trabajo colaborativo, utilizando Scrum, consta de 3 sprints (la final evaluada por un PO). El tema, una red social para programadores en español, es posible ser usuario PREMIUM por medio de un pago único con el cual podrían postearse contenidos de tipo video y así generar más tráfico por usuario",
      image: "./programared.png",
      link: "https://front-programa-red.vercel.app",
    },
    {
      title: "The Dogs Api",
      subtitle: "React-Redux Node Express Sequelize",
      description:
        'Desarrollo de una SPA (Single Page Application) utilizando React para el Front End y Redux como state management. Todos los componentes fueron desarrollados con CSS sin uso de librerías externas. La SPA consume datos de una API (“The Dogs Api”) a través de un Back End desarrollado en Node.JS utilizando Express, agregando nuevas funcionalidades a la API original.',
      image: "./dogs.png",
      link: "https://pi-dogs-client-sigma.vercel.app",
    },
    {
      title: "Rick & Morty App",
      subtitle: "React-Redux Node Express Sequelize",
      description:
        'Usuario: ejemplo@gmail.com, Password: Password1, Desarrollo de un SPA (Single page Application) consumiendo datos del api "The Rick and Morty API", la finalidad fue ir realizando un proyecto individual de a pocos mientras aprendía las diferentes técnologías del bootcamp: Javascript, Html, Css, Node, React, Redux, Express, PostgreSql, Sequelize, Testing',
      image: "./rick&morty.png",
      link: "https://rick-and-morty-front-six.vercel.app/",
    },
    // {
    //   title: "Epic Todo App",
    //   subtitle: "React Hooks",
    //   description:
    //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    //   image: "./project-4.gif",
    //   link: "https://pythonbootcamp.com",
    // },
  ];

  export const skills = [
    'JavaScript', 'PHP', 'NodeJS', 'React', 'Redux', 'SQL','Sequelize', 'HTML', 'CSS', 'PostgreSql'
  ] 